module.exports = __webpack_public_path__ + "img/empleados.6f7b8142.png";